import apiClient from './apiClient';

// Tag Type Services
export const getAllTagTypes = async () => {
  const response = await apiClient.post('/Tag/GetAllTagTypes');
  return response.data || [];
};

export const getTagTypeById = async (id) => {
  const response = await apiClient.post('/Tag/GetTagTypeById', null, { params: { id } });
  return response.data;
};

export const addTagType = async (tagType) => {
  const response = await apiClient.post('/Tag/AddTagType', tagType);
  return response.data;
};

export const updateTagType = async (tagType) => {
  const response = await apiClient.post('/Tag/UpdateTagType', tagType);
  return response.data;
};

export const deleteTagType = async (id) => {
  const response = await apiClient.post('/Tag/DeleteTagType', null, { params: { id } });
  return response.data;
};

// Tag Services
export const getAllTags = async () => {
  const response = await apiClient.post('/Tag/GetAllTags');
  return response.data || [];
};

export const getTagById = async (id) => {
  const response = await apiClient.post('/Tag/GetTagById', null, { params: { id } });
  return response.data;
};

export const getTagsByTypeId = async (id) => {
  const response = await apiClient.post('/Tag/GetTagsByTypeId', null, { params: { id } });
  return response.data || [];
};

export const addTag = async (tag) => {
  const response = await apiClient.post('/Tag/AddTag', tag);
  return response.data;
};

export const updateTag = async (tag) => {
  const response = await apiClient.post('/Tag/UpdateTag', tag);
  return response.data;
};

export const deleteTag = async (id) => {
  const response = await apiClient.post('/Tag/DeleteTag', null, { params: { id } });
  return response.data;
};